import { Button, Popconfirm, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { EditFilled, DeleteFilled } from '@ant-design/icons';

const Columns = (onEdit, onDelete, users = [], api) => {
  const navigate = useNavigate();

  const isRoleAssigned = (roleId) => {
    return users.some(user => user.roles?.some(r => r.id === roleId));
  };

  return [
    {
      title: "Nombre del Rol",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '70%',
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => {
        const assigned = isRoleAssigned(record.id);

        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <Button
              style={{ color: '#006939', fontSize: 18, padding: '0px 2px' }}
              type="link"
              onClick={() => onEdit(record)}
            >
              <Tooltip title="Editar rol"><EditFilled /></Tooltip>
            </Button>

            {assigned ? (
              <Button
                type="link"
                style={{ color: '#006939', fontSize: 18, padding: '0px 2px' }}
                onClick={() => {
                  api.error({
                    message: "No se puede eliminar el rol",
                    description: "Este rol está asignado a uno o más usuarios.",
                    placement: "topRight",
                    key: 'rol-error'
                  });
                }}
              >
                <Tooltip title="Eliminar rol"><DeleteFilled /></Tooltip>
              </Button>
            ) : (
              <Popconfirm
                overlayClassName="custom-popconfirm"
                title="¿Seguro que deseas eliminar este Rol?"
                onConfirm={() => onDelete(record.id)}
              >
                <Button type="link" style={{ color: '#006939', fontSize: 18, padding: '0px 2px' }}>
                  <Tooltip title="Eliminar rol"><DeleteFilled /></Tooltip>
                </Button>
              </Popconfirm>
            )}
          </div>
        );
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center',
      width: '10%',
    }  
  ];
};
  
export default Columns;